"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.patternMatchingReducer = void 0;
const pattern_1 = require("../actions/pattern");
const initState = '';
const patternMatchingReducer = (patternMatching = initState, action) => {
    switch (true) {
        case action.type === pattern_1.SET_PATTERN:
            return action.payload;
        case action.type === pattern_1.REMOVE_PATTERN:
            return initState;
        default:
            return patternMatching;
    }
};
exports.patternMatchingReducer = patternMatchingReducer;
//# sourceMappingURL=scPatternMatching.reducer.js.map